import CircularProgress from 'components/progress/CircularProgress';
import {Button as MuiButton}  from '@mui/material';
import * as React from 'react';


const LoadingButton = (props: any) => {
    const {loading, loadingColor, ...rest} = props;
    const LoadIcon= loading ? <CircularProgress style={{color: 'white'}} size={16} /> : null;

    return <MuiButton type="submit" endIcon={LoadIcon} variant="contained" {...rest} />
}

export default LoadingButton;